import {EMAIL_FORMAT} from '../constants/regex';

export default (email) => (EMAIL_FORMAT.test(email.toLowerCase()));